import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import RedeemActivityService from "service/RedeemActivity";

export const getAllRedeemActivities =
  (page: number = 1, search: string = "", limit: number = 10) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_REDEEM_ACTIVITY_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_REDEEM_ACTIVITY",
      searchValue: search,
    });

    try {
      const data = await RedeemActivityService.getRedeemActivities(
        page,
        search,
        limit
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_REDEEM_ACTIVITY", value: data.redeem_activities });
      dispatch({
        type: "SET_REDEEM_ACTIVITY_PAGE",
        totalPage: !!data.redeem_activities.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.redeem_activities.length ? data.total_data : 1,
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };